import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, toHandlers as _toHandlers, mergeProps as _mergeProps, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = { class: "o-input__imagecheckbox__ico" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "o-input__imagecheckbox__label" }
const _hoisted_5 = ["type", "id", "name", "placeholder", "value", "required", "checked"]
const _hoisted_6 = ["for"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "o-form__validation" }
const _hoisted_9 = {
  key: 0,
  class: "o-form__validation__required"
}
const _hoisted_10 = {
  key: 1,
  class: "o-form__validation__required"
}
const _hoisted_11 = { class: "o-form__validation__error" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_inputlabel = _resolveComponent("inputlabel")

  return (!$props.disabledIDs.includes($props.field.id))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass((!$props.field.inputClass) ? 'o-grid-12' : $props.field.inputClass)
      }, [
        _createVNode(_component_inputlabel, { field: $props.field }, null, 8 /* PROPS */, ["field"]),
        _createElementVNode("div", {
          class: _normalizeClass(["o-form__item o-input__imagecheckbox__container", {'o-radio__group': this.field.inputType === 'inlinecheckbox'}])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.choices, (choice, ci) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["o-input__imagecheckbox__wrap", {
                    'o-checkbox__wrap': this.field.inputType !== 'inlinecheckbox',
                    'o-radio__wrap': this.field.inputType === 'inlinecheckbox'
                }]),
              key: 'cb-'+ci+'-'+$props.field.id
            }, [
              _createElementVNode("label", null, [
                _createCommentVNode(" Inline SVG if available in svgContentMap "),
                _createElementVNode("span", _hoisted_2, [
                  (choice.picto && $data.svgContentMap[choice.picto])
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "",
                        innerHTML: $data.svgContentMap[choice.picto]
                      }, null, 8 /* PROPS */, _hoisted_3))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", _mergeProps({
                    class: ["o-input__imagecheckbox", { 
                                'o-checkbox': this.field.inputType !== 'inlinecheckbox',
                                'o-radio': this.field.inputType === 'inlinecheckbox',
                                'readonly': $props.field.inputReadonly === true,
                                'required': $data.requiredField === true
                            }],
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($props.field.value) = $event))
                  }, _toHandlers($data.readOnlyHandlers, true), {
                    type: ($props.field.inputChoicesMultiple) ? 'checkbox' : 'radio',
                    id: 'input-' +ci+'-'+$props.field.id,
                    name: ($props.field.inputChoices.length>1) ? $props.field.inputName+'[]' : $props.field.inputName,
                    placeholder: $props.field.inputPlaceholder,
                    value: (String(choice.value).trim() != '') ? choice.value : choice.text,
                    required: ($props.field.inputRequired === true && $props.field.value!==null && $props.field.value.length == 0) ? 'required' : false,
                    checked: ($props.field.value?.includes(choice.value)) ? 'checked' : false
                  }), null, 16 /* FULL_PROPS */, _hoisted_5), [
                    [_vModelDynamic, $props.field.value]
                  ]),
                  _createElementVNode("label", {
                    class: _normalizeClass({
                                'o-checkbox-label': this.field.inputType !== 'inlinecheckbox',
                                'o-radio-label': this.field.inputType === 'inlinecheckbox'
                            }),
                    for: 'input-' + ci + '-' + $props.field.id
                  }, [
                    _createElementVNode("span", {
                      innerHTML: (String(choice.text).trim() != '') ? choice.text : choice.value
                    }, null, 8 /* PROPS */, _hoisted_7)
                  ], 10 /* CLASS, PROPS */, _hoisted_6),
                  _createElementVNode("div", _hoisted_8, [
                    ($props.field.inputChoices.length<2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx._t('Vous devez choisir au moins un élément.')), 1 /* TEXT */)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx._t('Ce champ est invalide.')), 1 /* TEXT */)
                  ])
                ])
              ])
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */),
        _createCommentVNode(" <pre>{{ field }}</pre> ")
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}